var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"RelaxifyButton"},[_c('v-btn',_vm._g(_vm._b({directives:[{name:"ripple",rawName:"v-ripple",value:(false),expression:"false"}],class:_vm.color},'v-btn',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }